import { LobbyUser } from "../../infra";
import { isLocalhost } from "../../utils";
import { useBrowserStorage } from "./useBrowserStorage";

export type Session = {
  user: LobbyUser;
};

export const useSession = () => {
  const { getValue, setValue } = useBrowserStorage<Session>(
    "user-session",
    (session) => JSON.stringify(session),
    (json) => JSON.parse(json),
    isLocalhost()
  );
  let session = getValue();
  if (!session) {
    session = {
      user: {
        id: Math.random().toString().substring(2),
        name: "anonymous",
      },
    };
    setValue(session);
  }

  return { getValue, session, setValue };
};

export const useSessionUser = () => {
  const { session } = useSession();
  return session.user;
};
